import React from 'react';

export default () => {
    return (
        <div style={{ background: 'black', color: 'white', width: '100%', height: '100%', padding: '30px' }}>
            Missing component
        </div>
    );
};